export default __webpack_public_path__ + "static/media/blicz.25c3ea66.jpg";